import React from "react";
import styled from "@emotion/styled";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { alpha, useTheme } from "@mui/material/styles";

// Register Chart.js components
const lineLabels = {
  id: "lineLabels",
  afterDraw(chart) {
    const { ctx, data } = chart;
    ctx.save();
    data.datasets.forEach((dataset, i) => {
      const meta = chart.getDatasetMeta(i);
      meta.data.forEach((point, index) => {
        const value = dataset.data[index];
        if (value !== undefined && value !== null) {
          ctx.fillStyle = "#1e293b";
          ctx.font = "bold 10px 'Inter', sans-serif";
          ctx.textAlign = "center";
          ctx.textBaseline = "bottom";
          ctx.fillText(value, point.x, point.y - 8);
        }
      });
    });
    ctx.restore();
  },
};

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
);

const ChartWrapper = styled.div`
  height: 120px;
  width: 100%;
`;

const ProLineChart = ({ data = [], labels = [] }) => {
  const theme = useTheme();

  const chartData = React.useMemo(() => {
    return {
      labels:
        labels.length > 0
          ? labels
          : ["07:00", "12:00", "17:00", "22:00", "03:00", "08:00", "13:00"],
      datasets: [
        {
          label: "Activity",
          fill: true,
          backgroundColor: alpha(theme.palette.primary.main, 0.1),
          borderColor: theme.palette.primary.main,
          borderWidth: 2,
          pointRadius: 0,
          tension: 0.4,
          data: data.length > 0 ? data : [30, 45, 62, 40, 85, 30, 50],
        },
      ],
    };
  }, [theme.palette.primary.main, data, labels]);

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          display: true,
          color: "#94a3b8",
          font: {
            size: 10,
          },
        },
      },
      y: {
        grid: {
          color: "rgba(0,0,0,0.02)",
          drawBorder: false,
        },
        ticks: {
          display: true,
          color: "#94a3b8",
          font: {
            size: 10,
          },
          stepSize: 20,
        },
      },
    },
  };

  return (
    <ChartWrapper>
      <Line data={chartData} options={options} />
    </ChartWrapper>
  );
};

export default ProLineChart;
